import { designToken, quickProperty } from '../component-tokens';
import { sizeAttributes } from './utils';
export const iconBadgeData = {
    name: 'icon-badge',
    reactImports: 'IconBadge',
    attributes: Object.assign(Object.assign({}, sizeAttributes('36px')), { 'border-radius': quickProperty('4px'), '--goto-icon-size': quickProperty('24px'), '--goto-icon-color': designToken('text-02'), 'background-color': designToken('neutral-03'), display: quickProperty('grid'), 'place-items': quickProperty('center') }),
    variants: [
        {
            name: 'pdf',
            attributes: {
                '--goto-icon-color': designToken('danger-01'),
                'background-color': designToken('danger-02'),
            },
        },
        {
            name: 'document',
            attributes: {
                '--goto-icon-color': designToken('interactive-01'),
                'background-color': designToken('information-02'),
            },
        },
        {
            name: 'spreadsheet',
            attributes: {
                '--goto-icon-color': designToken('success-01'),
                'background-color': designToken('success-02'),
            },
        },
        {
            name: 'partner',
            attributes: {
                '--goto-icon-color': designToken('neutral-000'),
                'background-color': designToken('neutral-700'),
            },
        },
        {
            name: 'audio',
            attributes: {
                '--goto-icon-color': designToken('warning-01'),
                'background-color': designToken('warning-02'),
            },
        },
        {
            name: 'video',
            attributes: {
                '--goto-icon-color': designToken('purple-500'),
                'background-color': designToken('purple-03'),
            },
        },
        {
            name: 'sketch',
            attributes: {
                '--goto-icon-color': designToken('orange-300'),
                'background-color': designToken('orange-03'),
            },
        },
        {
            name: 'voice',
            attributes: {
                '--goto-icon-color': designToken('text-04'),
                'background-color': designToken('experience-badge-voice'),
            },
        },
        {
            name: 'meeting',
            attributes: {
                '--goto-icon-color': designToken('text-04'),
                'background-color': designToken('experience-badge-meeting'),
            },
        },
        {
            name: 'message',
            attributes: {
                '--goto-icon-color': designToken('text-04'),
                'background-color': designToken('experience-badge-message'),
            },
        },
        {
            name: 'assist',
            attributes: {
                '--goto-icon-color': designToken('text-04'),
                'background-color': designToken('experience-badge-assist'),
            },
        },
        {
            name: 'assistmobile',
            attributes: {
                '--goto-icon-color': designToken('text-04'),
                'background-color': designToken('experience-badge-assist'),
            },
        },
        {
            name: 'training',
            attributes: {
                '--goto-icon-color': designToken('text-04'),
                'background-color': designToken('experience-badge-training'),
            },
        },
        {
            name: 'webinar',
            attributes: {
                '--goto-icon-color': designToken('text-04'),
                'background-color': designToken('experience-badge-webinar'),
            },
        },
        {
            name: 'customer',
            attributes: {
                '--goto-icon-color': designToken('text-04'),
                'background-color': designToken('experience-badge-customer'),
            },
        },
        {
            name: 'custom',
            attributes: {
                '--goto-icon-color': designToken('text-04'),
                'background-color': designToken('neutral'),
            },
        },
        {
            name: 'gotoresolve',
            attributes: {
                '--goto-icon-color': designToken('text-04'),
                'background-color': designToken('experience-badge-gotoresolve'),
            },
        },
        {
            name: 'gotoresolveremotesupport',
            attributes: {
                '--goto-icon-color': designToken('text-04'),
                'background-color': designToken('experience-badge-gotoresolve'),
            },
        },
        {
            name: 'gotoresolvehelpdesk',
            attributes: {
                '--goto-icon-color': designToken('text-04'),
                'background-color': designToken('experience-badge-gotoresolve'),
            },
        },
        {
            name: 'gotoresolvemobile',
            attributes: {
                '--goto-icon-color': designToken('text-04'),
                'background-color': designToken('experience-badge-gotoresolve'),
            },
        },
        {
            name: 'gotoresolvecamerashare',
            attributes: {
                '--goto-icon-color': designToken('text-04'),
                'background-color': designToken('experience-badge-gotoresolve'),
            },
        },
    ],
    states: [
        {
            name: 'disabled',
            attributes: {
                'background-color': designToken('disabled-02'),
                color: designToken('disabled-04'),
                cursor: quickProperty('default'),
                '--goto-icon-color': designToken('disabled-04'),
            },
        },
    ],
    sizes: [
        {
            name: 'small',
            attributes: Object.assign(Object.assign({}, sizeAttributes('24px')), { '--goto-icon-size': quickProperty('16px') }),
        },
        {
            name: 'large',
            attributes: Object.assign(Object.assign({}, sizeAttributes('48px')), { '--goto-icon-size': quickProperty('32px'), 'border-radius': quickProperty('8px') }),
        },
    ],
};
export const iconBadgeTypes = [
    'audio',
    'calendar',
    'code',
    'contact',
    'custom',
    'document',
    'font',
    'image',
    'link',
    'pdf',
    'presentation',
    'sketch',
    'spreadsheet',
    'vector',
    'video',
    'zip',
    'call',
    'partner',
    'messaging',
    'meeting',
    'highlighter',
    'training',
    'assist',
    'assistmobile',
    'room',
    'webinar',
    'gotoresolve',
    'gotoresolveremotesupport',
    'gotoresolvehelpdesk',
    'gotoresolvemobile',
    'gotoresolvecamerashare',
];
export const iconBadgeSizes = ['small', 'medium', 'large'];
